import { Table } from "flowbite-react";
import { formatToReal } from "../../../utils/utils";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";

const RestritivaPF = ({ data }) => {
  return (
    <>
      <TitleStripe>Restritiva</TitleStripe>

      <div className="title-syncx mt-4">Negativações</div>
      {data?.Negative?.Apontamentos?.Apontamento?.length > 0 ? (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Data
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Empresa
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Contrato
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Valor
              </td>
            </Table.Head>
            <Table.Body>
              {data?.Negative?.Apontamentos?.Apontamento?.map(
                (debit, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-100"
                    }`}
                  >
                    <td className="p-1">
                      {debit.DateOccurred.Day}/{debit.DateOccurred.Month}/
                      {debit.DateOccurred.Year}
                    </td>
                    <td className="p-1 text-center">{debit.CompanyName}</td>
                    <td className="p-1 text-center">{debit.ContractNumber}</td>
                    <td className="p-1 text-center">
                      {formatToReal(debit.Amount)}
                    </td>
                  </tr>
                )
              )}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <NoOcurrence />
      )}

      <div className="title-syncx mt-4">Cheques sem fundo</div>
      {data?.Negative?.CcfApontamentos?.CcfApontamento?.length > 0 ? (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Data
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Banco
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Documento
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Qtd
              </td>
            </Table.Head>
            <Table.Body>
              {data?.Negative?.CcfApontamentos?.CcfApontamento?.map(
                (debit, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-100"
                    }`}
                  >
                    <td className="p-1">
                      {debit.DateLastBounce.Day}/{debit.DateLastBounce.Month}/
                      {debit.DateLastBounce.Year}
                    </td>
                    <td className="p-1 text-center">
                      {debit.ReportingNameBank}
                    </td>
                    <td className="p-1 text-center">{debit.CpfCnpj}</td>
                    <td className="p-1 text-center">{debit.CountBounce}</td>
                  </tr>
                )
              )}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <NoOcurrence />
      )}
    </>
  );
};

export default RestritivaPF;
